// removed by extract-text-webpack-plugin
module.exports = {"Container":"T5gYKjoDEdW8oukSZwT-v","DashboardWrapper":"_2zjFHxZNY7EiUJZzJZjG_h","FullBleed":"_15Z_BBjzJkkXAkthUlDPrX","FlexRow":"_1-9PuMCjlLpIRs3spccSAV","SummaryRow":"_2V33Tu6idwNnXGmOsCHjzk"};


//////////////////
// WEBPACK FOOTER
// ./src/PagesOfUser/Dashboard/styles.module.css
// module id = 627
// module chunks = 0